module.exports = __webpack_public_path__ + "23fb27d8d097e2ad61d43dfacb1a6531.svg";